import { styled } from '@lyfta/components-theme'

const ImageObject = styled.img`
  border: 0;
`

export default ImageObject
